export const SETTINGS_ENDPOINTS_URLS = {
  readPaymentSettings: "settings/payment",
  updatePaymentSettings: "settings/payment",
};

export const SETTINGS_TAGS = {
  settings: "settings",
};
